import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../../../../../shared';
import { SharedAuthService } from '../../../../../shared/shared.auth.service';
import { MaintenanceService } from '../../../../../techopsv4/services/maintenanceService';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-ot-labor-proposal',
    templateUrl: './ot-labor-proposal.component.html',
    styleUrl: './ot-labor-proposal.component.css',
    standalone: false
})
export class OtLaborProposalComponent {
    requestChecked = true;
    proposalChecked = false;
    selectedOption: any = 'requests';
    breadCrumbName: any = 'My Requests';
    approvalChecked: boolean = false;
    showTable:boolean = false;
    normalUser :boolean = false;
    loadMyRequests = false;
    proposalIdsForView = [];
    proposalCreateRoles = [];
    proposalApproveRoles = [];
    isUCMGOwner = false;
    tabs: Array<any> = [ { label: 'My Requests', value: 'requests' },
    { label: 'My Approvals', value: 'approvals' }];
  
    constructor(

      public sharedAuthService: SharedAuthService,
      public sharedService: SharedService,
      public maintenanceService: MaintenanceService,
      private route: Router,
      private activeRoute: ActivatedRoute){
    }

ngOnInit (){
      if (!sessionStorage.getItem('techaccessData')) {
        this.sharedAuthService.userAccessDataSource.pipe(take(1)).subscribe(accessData => {
          this.checkuserAccess();
        });
      } else {
       this.checkuserAccess();
      }
    }

    checkuserAccess(){
      //Funding Admin and FO/FD Check
      const isFundingAdmin = this.sharedAuthService.getFundingAccessDetails('');
      let isFOFDSegList = this.sharedAuthService.getFundingAccessDetails('Segmentlist');

      //UCMG Owner Check
      let isUCMGOwner = false;
      let techAccessData: {UCMG_Owner?: any[]} = {};
      try {
        techAccessData = JSON.parse(sessionStorage.getItem('techaccessData')) || {UCMG_Owner: []};
        if(Array.isArray(techAccessData.UCMG_Owner) && techAccessData.UCMG_Owner.length > 0){
          isUCMGOwner = true;
          this.isUCMGOwner = isUCMGOwner && !isFundingAdmin && isFOFDSegList?.length == 0 ? true : false; //only give UCMG Owner permissions if not Funding Admin or FD/FD;
        }
      } catch (e) {
        techAccessData = {};
      }

      this.normalUser = !isUCMGOwner && !isFundingAdmin && isFOFDSegList?.length == 0 ? true : false;
      if(this.normalUser){
       this.selectionTypeChange('requests');
      } else {
        //Read Query Params
        this.readURLQueryParams();
      }
    }

    readURLQueryParams(){
      this.activeRoute.queryParamMap.subscribe((qp) => {
        const selectedOption = qp.get('selectedOption');
        if (selectedOption && ['requests','approvals'].includes(selectedOption)) {
          this.selectionTypeChange(selectedOption);
        }
        else if (qp.get('selectedTab')=='OT-Labor-Proposal' && selectedOption == null) {
          this.selectionTypeChange(this.selectedOption);
        }
      });
    }

  selectionTypeChange(event) {
    const selectedTabValue = typeof event === 'string' ? event : this.tabs[event.index].value;
    const currentSelectedTab = this.activeRoute.snapshot.queryParamMap.get('selectedTab');
    if (currentSelectedTab === 'OT-Labor-Proposal') {
      this.route.navigate([], {
        queryParams: { selectedOption: selectedTabValue },
        queryParamsHandling: 'merge'
      });
    }
    this.updateSelectedOption(selectedTabValue);
    if (selectedTabValue== 'requests') {
      this.breadCrumbName = 'My Requests';
      this.requestChecked = true;
      this.proposalChecked = false;
      this.approvalChecked =false;
      this.showTable = false;
    }
    // if (selectedTabValue == 'proposal') {
    //   this.breadCrumbName = 'Work Queues';
    //   this.proposalChecked = true;
    //   this.requestChecked = false;
    //   this.approvalChecked =false;
    //   this.showTable = false;
    // }
    // if (selectedTabValue == 'proposal-dashboard') {
    //   this.breadCrumbName = 'Work Queues Summary';
    //   this.proposalChecked = false;
    //   this.requestChecked = false;
    //   this.approvalChecked =true;
    //   this.showTable = false;
    // }

    
  }

  getSelectedTabIndex(): number {
    const index = this.tabs.findIndex(tab => tab.value === this.selectedOption);
    return index >= 0 ? index : 0;
  }

  updateSelectedOption(newValue: any) {
    this.selectedOption = newValue;
  }

}
